import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
export const styles = (theme: Theme) => {
	return ({
		radioLabel: {
			marginRight: "30px",
			paddingTop: "14px"
		},
		root: {
			marginRight: 0,
			"& .MuiFormControlLabel-label": {
				marginLeft: 8,
			},
		},
		radioGroup: {
			display: "flex"
		},
		// Checked toggles use brand orange (#E85F2A = custom.primary) across the refresh (MAX-3863).
		switchColor: {
			"& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
				backgroundColor: theme.palette.custom.primary,
			},
		},
		switch: {
			marginTop: 0,
		},
		label: {
			alignItems: "flex-start",
		},
		labelText: {
			color: theme.palette.custom.textPrimary,
		},
		descriptionText: {
			color: theme.palette.custom.textPrimary,
		},
	} satisfies Record<string, CSSObject>);
};
